import { ETripTaskType, TripTaskType } from 'types/trips';

export const TASK_TYPE_OPTIONS = Object.entries(TripTaskType)
  .filter(([key]) => key !== ETripTaskType.trailer_swap && key !== ETripTaskType.return_asset)
  .map(([key, value]) => ({
    value: key,
    label: value,
  }));

export const RETURN_ASSET_TASK_TYPE_OPTION = {
  value: ETripTaskType.return_asset,
  label: TripTaskType[ETripTaskType.return_asset],
};
